import type {
	CommandMatches,
	ListedCommand,
	FlattenedCommand,
	OrderedFilteredCommands,
} from '../../types/commands/index.tsx';

export const getFlattenedResults = (
	groupedCommands: OrderedFilteredCommands,
	activeIndex: number,
): CommandMatches => {
	const ungroupedCommands = groupedCommands.ungrouped.slice(0);
	let results: FlattenedCommand[] = ungroupedCommands;

	const sortedGroups = Object.values(groupedCommands.grouped);

	sortedGroups.forEach(({ id, group, renderGroup, commands: groupCommands }) => {
		results = results.concat(
			{
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				...(renderGroup ? { renderGroup } : { group: group as string }),
				isGroup: true,
				id,
			},
			groupCommands,
		);
	});

	const hasAction = (listed: ListedCommand) =>
		Boolean(listed.command.primaryAction || listed.command.secondaryAction);

	let index = 0;
	let totalActionableCommands = 0;
	let activeCommand;
	let sectionIndex = -1;
	let indexWithinSection = 0;
	let sectionId: string | undefined;
	results = results.map((result) => {
		if (result.isGroup) {
			const newResult = result;
			indexWithinSection = 0;
			sectionIndex += 1;
			newResult.index = sectionIndex;
			sectionId = result.id;
		}
		if (!result.isGroup) {
			const newResult = result;
			if (hasAction(result)) {
				newResult.index = index;
				index += 1;
				totalActionableCommands += 1;
				newResult.active = activeIndex === result.index;
			}

			newResult.indexWithinSection = indexWithinSection;
			newResult.sectionIndex = sectionIndex;
			newResult.sectionId = sectionId;
			indexWithinSection += 1;
			if (newResult.active) {
				activeCommand = newResult.command;
			}
			return newResult;
		}

		return result;
	});

	return {
		results,
		total: totalActionableCommands,
		activeCommand,
	};
};
